import { useEffect } from "react";
import { supportedLngs } from "../../utils/ConstCapture";

const handleDetectLanguage = () => {
  var ln = navigator.language || navigator.userLanguage;

  // Convertir el código de idioma a minúsculas para asegurar compatibilidad

  ln = ln.toLowerCase();
  if (ln && ln.split("-")[0] === "en" && supportedLngs.includes("en")) {
    return "en";
  } else if (ln && ln.split("-")[0] === "ro" && supportedLngs.includes("ro")) {
    return "ro";
  } else {
    return "es";
  }
};
const LanguageRedirect = () => {
  const path = window.location.pathname.split("/");
  const pathLanguage = supportedLngs.includes(path[1]) ? path[1] : "";
  let ln = navigator.language || navigator.userLanguage;
  ln = ln.toLowerCase();

  useEffect(() => {
    if (!pathLanguage) {
      history.pushState(
        null,
        "",
        `/${handleDetectLanguage()}${window.location.pathname}`
      );
      location.reload();
    }
  }, [pathLanguage]);

  return null; // Este componente no renderiza nada
};

export default LanguageRedirect;
